import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import Home from './pages/Home';
import Pricing from './pages/pricing';
import About from './pages/about';
import Integrations from './pages/Integrations';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import SignUp from './pages/SignUp';
import Mcp from './pages/Mcp';
import Support from './pages/Support';
import Careers from './pages/Careers';
import NotFound from './pages/NotFound';
import CookieConsent from './components/common/CookieConsent';
import { CookieConsentProvider } from './context/CookieConsentContext';
import Security from './pages/Security';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <Header />
    <main className="flex-1 pt-16">
      {children}
    </main>
    <Footer />
    <CookieConsent />
  </div>
);

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <CookieConsentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/signup" element={<SignUp />} />
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
            <Route path="/about-us" element={<Layout><About /></Layout>} />
            <Route path="/integrations" element={<Layout><Integrations /></Layout>} />
            <Route path="/privacy-policy" element={<Layout><Privacy /></Layout>} />
            <Route path="/terms-of-use" element={<Layout><Terms /></Layout>} />
            <Route path="/cobalt-mcp" element={<Layout><Mcp /></Layout>} />
            <Route path="/support-policy" element={<Layout><Support /></Layout>} />
            <Route path="/careers" element={<Layout><Careers /></Layout>} />
            <Route path="/security" element={<Layout><Security /></Layout>} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </CookieConsentProvider>
    </HelmetProvider>
  );
};

export default App;